export default {
  populate: {
    owner: {
      fields: "id",
    },
    image: true,
    localizations: true,
    price_type: true,
    facility: {
      fields: ["id", "businessName"],
    },
  },
};
